import { isUndefined, uniqueId } from 'lodash'
import { FiltersActions } from 'src/App/actions'
import { addNotification } from 'components/Notifications/actions'
import {
  deleteFilter,
  fetchAsyncFilterSections,
  fetchDefaultFilter,
  fetchFilter,
  fetchFilterList,
  insertFilter,
  updateFilter
} from 'services/api/filterbar'

export const createFilterbarApiActions = (outputName, instanceId) => ({
  getAsyncFilterSections: async (filterData, changedSection, asyncDeps) =>
    await fetchAsyncFilterSections({
      outputName,
      changedSection,
      instanceId,
      asyncDeps,
      filterData
    }),
  getFilterList: async (defaultFilter = false, signal) =>
    await fetchFilterList(outputName, instanceId, defaultFilter,signal),
  getFilter: async (id) => await fetchFilter(id, outputName),
  getDefaultFilter: async () =>
    await fetchDefaultFilter(instanceId, outputName),
  updateFilter: async (id, body) => await updateFilter(id, body, outputName),
  saveFilter: async (body) => await insertFilter(body, outputName),
  deleteFilter: async (id) => await deleteFilter(id, outputName)
})

export const getListAndFavorite = async (outputName) => {
  const { getFilterList } = createFilterbarApiActions(outputName)

  const list = await getFilterList()
  const favoriteFilter = list.find((item) => item.favorite)
  const filterList = list.sort((a, b) => a.name.localeCompare(b.name))

  return { filterList, favoriteFilter }
}

export const saveFilterHandler = async ({ id, ...body }, outputName, t) => {
  const { name, sections } = body
  const { saveFilter, updateFilter } = createFilterbarApiActions(outputName)

  if (isUndefined(id)) {
    await saveFilter(body)
  } else {
    await updateFilter(id, body)
  }

  FiltersActions.update((prevState) => ({
    ...prevState,
    sections,
    filterName: name
  }))

  addNotification({
    id: uniqueId('notif-'),
    title: `${t(
      isUndefined(id) ? 'MODAL_FILTER_ADDED' : 'MODAL_FILTER_UPDATED'
    )}: ${name}`,
    type: 'inline',
    kind: 'success'
  })
}
